import { sum } from 'ramda';

export const TRANSITION_DELAY = 500;
export const TRANSITION_DURATION = 500;
export const FADE_IN_TRANSITION_DURATION = 200;
export const FADE_IN_UP_TRANSITION_DURATION = 200;
export const TRANSITION_COOLDOWN = 100;
export const TRANSITION_TOTAL_DURATION = sum([TRANSITION_DELAY, TRANSITION_DURATION, TRANSITION_COOLDOWN]);
export const FADE_IN_UP_TRANSITION_TOTAL_DURATION = FADE_IN_UP_TRANSITION_DURATION;
